import {useParams} from "react-router-dom";

const useIsAccountPage = () => {
    const { acctPage } = useParams();
    return acctPage === "account";
}

export default useIsAccountPage;
